let host = 'http://registrationformbackend.test.aws.jyllands-posten.dk'

// Production endpoint
if (process.env.NODE_ENV === "production") {
  host = 'http://registrationformbackend.prod.aws.jyllands-posten.dk'
}

export default {
  registrationPost(data) {
    return new Promise((resolve, reject) => {
      var request = new XMLHttpRequest()

      request.open('POST', host + '/registration', true)

      request.setRequestHeader('Accept', 'application/json')
      request.setRequestHeader('Content-Type', 'application/json')

      request.onload = () => {
        if (request.status >= 200 && request.status < 300) {
          resolve(JSON.parse(request.responseText))
        } else {
          reject()
        }
      }

      request.onerror = () => {
        reject()
      }

      request.send(JSON.stringify(data))
    })
  }
}



// WEBPACK FOOTER //
// ./src/apiClient.js